import "../styles/global.scss";
import "./Router.scss";

import { Suspense, lazy } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import Loader from "../components/UI/Loader";

const Ready = lazy(() => import("../screens/Ready"));
const Test = lazy(() => import("../screens/Test"));
const Finished = lazy(() => import("../screens/Finished"));
const Interested = lazy(() => import("../screens/Interested"));
const Login = lazy(() => import("../screens/Login"));
const Administration = lazy(() => import("../screens/Administration"));
const ApplicantDetail = lazy(() => import("../screens/ApplicantDetail"));
const PreTest = lazy(() => import("../screens/PreTest"));
// const Register = lazy(() => import("../screens/Register"));

const PrivateRoute = ({
  component: Component,
  exact,
  path,
  ...rest
}: {
  component: React.LazyExoticComponent<() => JSX.Element>;
  exact: boolean;
  path: string;
}) => {
  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(router: any) => <Component {...router} />}
    />
  );
};

function App() {
  const main = (
    <main>
      <div className="responzive-layout">
        <div className="flex-1 main">
          <Switch>
            <Route component={Ready} exact path="/" />
            <Route component={Test} exact path="/iquest-test" />
            <Route component={PreTest} exact path="/pre-test" />
            <Route component={Interested} exact path="/interested" />
            <Route component={Finished} exact path="/finished" />
            <Route component={Login} exact path="/login" />
            {/* <Route component={Register} exact path="/register" /> */}
            <PrivateRoute
              component={Administration}
              exact
              path="/administration"
            />
            <PrivateRoute
              component={ApplicantDetail}
              exact
              path="/applicant-detail/:refId"
            />
          </Switch>
        </div>
      </div>
    </main>
  );

  return (
    <Suspense fallback={<Loader center />}>
      <Router>
        <div className="App" id="pageLayout">
          <div className="rounded-top--white-bg" />
          <div className="rounded-top" />
          {main}
        </div>
      </Router>
    </Suspense>
  );
}

export default App;
